import { Box, Typography, useMediaQuery } from "@mui/material";

import { PropsWithChildren } from "react";
import React from "react";
import { createStyleSheet } from "../utils/styles";
import { theme } from "../../theme";

const DetailCell = (
  props: PropsWithChildren<{
    title: string;
    body?: string;
    subTitle?: string;
    first?: boolean;
    last?: boolean;
  }>
) => {
  const isMobile = useMediaQuery(theme.breakpoints.down("desktop"));
  return (
    <Box
      sx={{
        ...styles.container,
        ...(!props.first && {
          paddingLeft: isMobile ? 1 : 2,
          borderLeft: (theme) => `1px solid ${theme.palette.divider}`,
          height: "100%",
        }),
        ...(!props.last && {
          paddingRight: isMobile ? 1 : 2,
        }),
      }}
    >
      <Typography variant="detailCellTitle">{props.title}</Typography>
      {props.body ? (
        <Typography variant="detailCellBody">{props.body}</Typography>
      ) : null}
      {props.children}
      {props.subTitle ? (
        <Typography variant="detailCellSubtitle">{props.subTitle}</Typography>
      ) : null}
    </Box>
  );
};

const styles = createStyleSheet({
  container: {
    display: "flex",
    flexWrap: "nowrap",
    flexDirection: "column",
  },
});

export default DetailCell;
